import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Card = ({ node }) => (
  <div data-testid={`genealogy-node-${node.id}`} className="inline-block vellum px-4 py-3 min-w-[9rem] max-w-[14rem] lift">
    <p className="font-heading font-bold text-sm text-[color:var(--accent)]">
      {node.link_slug
        ? <Link to={`/wiki/${node.link_slug}`} className="hover:text-[color:var(--accent-bright)] underline decoration-[#c9a227] underline-offset-4">{node.name}</Link>
        : node.name}
    </p>
    {node.years && <p className="text-xs italic text-[#5e4a35]">{node.years}</p>}
    {node.spouse && <p className="text-xs mt-1 inline-flex items-center gap-1 text-[#4a3a2a]"><Heart className="w-3 h-3 text-[#991b1b]" /> {node.spouse}</p>}
  </div>
);

const buildTree = (nodes, kids, list, depth) =>
  list.map((node) => {
    const children = depth < 30 ? kids(node.id) : [];
    return { node, children: buildTree(nodes, kids, children, depth + 1) };
  });

const flatten = (branches) => branches.map(({ node, children }) => ({ node, childList: flatten(children) }));

const Branches = ({ items }) => {
  const render = (list) => list.map(({ node, childList }) => (
    <li key={node.id}>
      <Card node={node} />
      {childList.length > 0 ? <ul>{render(childList)}</ul> : null}
    </li>
  ));
  return <ul>{render(items)}</ul>;
};

export const GenealogyTree = ({ nodes = [] }) => {
  if (!nodes.length) return null;
  const ids = new Set(nodes.map((n) => n.id));
  const kids = (pid) => nodes.filter((n) => n.parent_id === pid && n.id !== pid);
  const roots = nodes.filter((n) => !n.parent_id || !ids.has(n.parent_id) || n.parent_id === n.id);
  const items = flatten(buildTree(nodes, kids, roots, 0));
  return (
    <div data-testid="genealogy-tree" className="overflow-x-auto pb-4">
      <div className="gtree min-w-max mx-auto px-4 py-6 text-center">
        <Branches items={items} />
      </div>
    </div>
  );
};
